import type { SpeedJobResponse, SpeedJobStatus } from '@/lib/api/speed';

const ACTIVE_JOB_STATUSES = new Set<SpeedJobStatus>([
    'queued',
    'running',
    'actionRequired',
    'authorizationRequired',
    'bridging',
]);

export function isActiveSpeedJob(job: SpeedJobResponse): boolean {
    return ACTIVE_JOB_STATUSES.has(job.status);
}
